import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IPlanDetailType from '../../models/IPlanDetailType';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';
import { Column } from 'devextreme-react/data-grid';
import { GroupItem, SimpleItem, Label } from 'devextreme-react/form';

interface IGestionProps {
  isModeSelection?: boolean;
}

class PlanDetailType extends IBaseModel implements IPlanDetailType {
  idPlanDetailType: Guid = Guid.empty;
  descriptionFrancaise: string = '';
  descriptionAnglaise: string = '';
  ordreAffichage: number = 0;
}

export default function GestionPlanDetailType({ isModeSelection }: IGestionProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="PlanDetailType" model={PlanDetailType}
      additionalColumns={
        <>
          <Column key={"grid-col-descriptionFrancaise"} dataField={"descriptionFrancaise"} caption="Description française" allowHiding={false} />
          <Column key={"grid-col-descriptionAnglaise"} dataField={"descriptionAnglaise"} caption="Description anglaise" allowHiding={false} />
        </>
      }
      customFormItems={(selectedPlanDetailType) => (
        <GroupItem>
          <SimpleItem key={"frm-description-francaise"} dataField={"descriptionFrancaise"}>
            <Label text={'Description française'} />
          </SimpleItem>
          <SimpleItem key={"frm-description-anglais"} dataField={"descriptionAnglaise"}>
            <Label text={'Description anglaise'} />
          </SimpleItem>
          <SimpleItem key={"frm-ordre-affichage"} dataField={"ordreAffichage"} editorType={"dxNumberBox"}>
            <Label text={'Ordre d\'affichage'} />
          </SimpleItem>
        </GroupItem>
      )}
    />
  );
}